import './cta-button.scss'
import { CmsLinkComponent } from '@omnia/ui/src/lib/cms/components/cmsLink/CmsLink'
import type { FC, ReactNode } from 'react'
import type { CtaButtonPropsApi } from '@/common/components/ctaButton/models'

/**
 * DevNote: This is basically a cta-link, but it called a button on cms, so we have to align with that
 * */
interface ButtonProps extends CtaButtonPropsApi {
    children?: ReactNode
    className?: string
}

export const CtaButton: FC<ButtonProps> = props => {
    const { link, children, className } = props ?? {}
    const { label = 'black' } = props.buttonColor ?? {}

    return (
        <CmsLinkComponent
            link={link}
            className={`cta-button v-button v-button--size-medium v-button--color-secondary ${label.toLowerCase()} ${className}`}
        >
            {children}
        </CmsLinkComponent>
    )
}
